/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Delete_MsgInputs */

const en_confirm_delete_msg = /** @type {(inputs: Confirm_Delete_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this message?`)
};

const id_confirm_delete_msg = /** @type {(inputs: Confirm_Delete_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah Anda yakin ingin menghapus pesan ini?`)
};

/** @type {(inputs: Confirm_Delete_MsgInputs) => LocalizedString} */
const es_confirm_delete_msg = en_confirm_delete_msg;

/** @type {(inputs: Confirm_Delete_MsgInputs) => LocalizedString} */
const fr_confirm_delete_msg = en_confirm_delete_msg;

/** @type {(inputs: Confirm_Delete_MsgInputs) => LocalizedString} */
const de_confirm_delete_msg = en_confirm_delete_msg;

/** @type {(inputs: Confirm_Delete_MsgInputs) => LocalizedString} */
const ja_confirm_delete_msg = en_confirm_delete_msg;

/** @type {(inputs: Confirm_Delete_MsgInputs) => LocalizedString} */
const zh_confirm_delete_msg = en_confirm_delete_msg;

/** @type {(inputs: Confirm_Delete_MsgInputs) => LocalizedString} */
const ar_confirm_delete_msg = en_confirm_delete_msg;

/** @type {(inputs: Confirm_Delete_MsgInputs) => LocalizedString} */
const it_confirm_delete_msg = en_confirm_delete_msg;

/** @type {(inputs: Confirm_Delete_MsgInputs) => LocalizedString} */
const ru_confirm_delete_msg = en_confirm_delete_msg;

/** @type {(inputs: Confirm_Delete_MsgInputs) => LocalizedString} */
const pt_confirm_delete_msg = en_confirm_delete_msg;

/** @type {(inputs: Confirm_Delete_MsgInputs) => LocalizedString} */
const ko_confirm_delete_msg = en_confirm_delete_msg;

/**
* | output |
* | --- |
* | "Are you sure you want to delete this message?" |
*
* @param {Confirm_Delete_MsgInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const confirm_delete_msg = /** @type {((inputs?: Confirm_Delete_MsgInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Delete_MsgInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_delete_msg(inputs)
	if (locale === "es") return es_confirm_delete_msg(inputs)
	if (locale === "fr") return fr_confirm_delete_msg(inputs)
	if (locale === "de") return de_confirm_delete_msg(inputs)
	if (locale === "ja") return ja_confirm_delete_msg(inputs)
	if (locale === "zh") return zh_confirm_delete_msg(inputs)
	if (locale === "ar") return ar_confirm_delete_msg(inputs)
	if (locale === "id") return id_confirm_delete_msg(inputs)
	if (locale === "it") return it_confirm_delete_msg(inputs)
	if (locale === "ru") return ru_confirm_delete_msg(inputs)
	if (locale === "pt") return pt_confirm_delete_msg(inputs)
	return ko_confirm_delete_msg(inputs)
});